// extracted by mini-css-extract-plugin
export default {"maincontainer":"speakers_maincontainer__Lq7uw","container":"speakers_container__DAiVP"};